// extracted by css-extract-rspack-plugin
export default {"view":"MenuSection-module__view___gz_t0"};